/**
 * Returns null if the elment does not exist. Otherwise boolean
 * depending on whether the element is in view or not.
 */
export function isInView(selector: string): boolean | null {
  const element = document.querySelector(selector)
  if (!element) return null

  const bounding = element.getBoundingClientRect()
  return (
    bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
  )
}
